import nav from './nav_private';
import nav_public from './nav.json';
import hero from './hero.json';
import pricing from './pricing.json';
import auth from './auth.json';
import features from './features.json';
import howItWorks from './howItWorks.json';
import testimonials from './testimonials.json';
import cta from './cta.json';
import footer from './footer.json';
import contact from './contact.json';
import menu from './menu';
import profile from './profile';
import subscription from './subscription';
import dashboard from './dashboard.json';
import faq from './faq.json';
import legal from './legal.json';
import security from './security.json';
import compare from './compare.json';
import socialProof from './socialProof.json';
import ideas from './ideas.json';
import experiments from './experiments.json';
import viewUsage from './viewUsage.json';
import adAccounts from './adAccounts.json';
import billing from './billing.json';

export default {
    nav,
    nav_public,
    hero,
    pricing,
    auth,
    features,
    howItWorks,
    testimonials,
    cta,
    footer,
    contact,
    menu,
    profile,
    subscription,
    dashboard,
    faq,
    legal,
    security,
    compare,
    socialProof,
    ideas,
    experiments,
    viewUsage,
    adAccounts,
    billing,
};
